
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { namespace } from 'vuex-class';
import { Component } from 'vue-property-decorator';
import { ENTRY_WIZARD_ACTIVITY, ENTRY_WIZARD_CONFIRMATION } from '@/router';

import { NAME } from '../store/index';
const modul = namespace(NAME);

//Components
import LocalUnitEditCensus from './LocalUnitEditCensus.vue';

//Getters und Actions
import { CASE_FULL_DATA, CASE_LOCAL_UNIT } from '../store/getters';
import { ICaseFullDataViewModel, CaseStepInfoViewModel, ILocalUnitDataObject } from '@/api-viewmodel';
import { CensusStepIndex } from '../views/Wizard.vue';
import StepHeader from './StepHeader.vue';

//Footer-Bar und -Buttons
import { NAME as NAME_FOOTERBAR } from '@/store/modules/footerBar';
const footerBarModul = namespace(NAME_FOOTERBAR);
import { NEW_BUTTON, CLOSE, DISABLE_BUTTONRIGHT } from '@/store/modules/footerBar/actions';
import { FooterButtonType, IFooterButton } from '@/store/modules/footerBar/state';
import { SUBMIT_CASE_STEPINFO } from '../store/actions';

import FooterBarRightButtonProxy from '@/components/FooterBarRightButtonProxy.vue';
@Component({
    components: { StepHeader, LocalUnitEditCensus, FooterBarRightButtonProxy, ValidationObserver }
})

/** Census-Step im Entry Wizard
 * @remarks Implementiert den
 *  {@link:https://collaboration.nowhow.ch/erst/foswiki/bin/view/Erst/DatenErfassungLocalCensusScreen}
 */
export default class StepCensus extends Vue {
    //Getters
    @modul.Getter(CASE_FULL_DATA) caseFullData!: ICaseFullDataViewModel;
    @modul.Getter(CASE_LOCAL_UNIT) localUnit!: ILocalUnitDataObject;

    //Actions
    @modul.Action(SUBMIT_CASE_STEPINFO) submitStepInfo!: Function;
    @footerBarModul.Action(NEW_BUTTON) newFooterBar!: Function;
    @footerBarModul.Action(CLOSE) closeFooterBar!: Function;
    @footerBarModul.Action(DISABLE_BUTTONRIGHT) disableButtonRight!: Function;

    mounted() {
        console.debug('StepCensus.vue::mounted');

        //Den aktuellen Step sofort melden
        this.submitStepInfo({
            caseId: this.caseFullData.caseId,
            data: new CaseStepInfoViewModel(CensusStepIndex, null)
        });

        this.showStepNavigation();
    }

    /** Definiert die Wizard-Navigations-Buttons und zeigt diese an */
    showStepNavigation() {
        console.debug('StepCensus.vue::showStepNavigation');
        const buttonLeft: Array<IFooterButton> = [
            {
                onClick: () => {
                    this.gotoPreviousStep();
                },
                label: 'btn_wzrd_back',
                type: FooterButtonType.secondary
            }
        ];
        const buttonRight: Array<IFooterButton> = [
            {
                onClick: () => {
                    this.gotoNextStep();
                },
                label: 'btn_wzrd_next',
                type: FooterButtonType.primary
            }
        ];
        this.closeFooterBar();
        this.newFooterBar({ buttonLeft, buttonRight });
    }

    /** Navigiert zum vorangehenden Step im Entry-Wizard. */
    gotoPreviousStep() {
        this.$router.push({ name: ENTRY_WIZARD_ACTIVITY });
    }

    /** Navigiert zum nächsten Step im Entry-Wizard. */
    gotoNextStep() {
        this.$router.push({ name: ENTRY_WIZARD_CONFIRMATION });
    }
}
